export const GUEST_EMAIL = '__guest_autologin__@local';
export const AUTH_LOGGED_OUT_KEY = 'auth_logged_out';

export function isGuestUser(user) {
  return Boolean(user && user.email === GUEST_EMAIL);
}
